import { apiClient } from './apiClient';
import type { ApiResponse } from '../types';
import type {
  Communication,
  CommunicationDetail,
  CommunicationListQuery,
  CommunicationListResponse,
  RetriggerCommunicationRequest,
  RetriggerCommunicationResponse,
} from '../types/communication';

function buildQuery(q?: CommunicationListQuery): string {
  if (!q) return '';
  const p = new URLSearchParams();
  if (q.channel) p.append('channel', q.channel);
  if (q.status) p.append('status', q.status);
  if (q.bounceStatus) p.append('bounceStatus', q.bounceStatus);
  if (q.templateName) p.append('templateName', q.templateName);
  if (q.triggeredFrom) p.append('triggeredFrom', q.triggeredFrom);
  if (q.triggeredByUserId) p.append('triggeredByUserId', q.triggeredByUserId);
  if (q.triggeredFromEntityType) p.append('triggeredFromEntityType', q.triggeredFromEntityType);
  if (q.triggeredFromEntityId) p.append('triggeredFromEntityId', q.triggeredFromEntityId);
  if (q.fromDate) p.append('fromDate', q.fromDate);
  if (q.toDate) p.append('toDate', q.toDate);
  if (q.search) p.append('search', q.search);
  if (q.page) p.append('page', String(q.page));
  if (q.pageSize) p.append('pageSize', String(q.pageSize));
  const s = p.toString();
  return s ? `?${s}` : '';
}

export const communicationService = {
  async listForPatient(
    patientId: string,
    query?: CommunicationListQuery,
  ): Promise<CommunicationListResponse> {
    const url = `/communications/patient/${patientId}${buildQuery(query)}`;
    const res = await apiClient.get<ApiResponse<CommunicationListResponse>>(url);
    return res.data.data;
  },

  async listForProgram(
    programId: string,
    query?: CommunicationListQuery,
  ): Promise<CommunicationListResponse> {
    const url = `/programs/${programId}/communications${buildQuery(query)}`;
    const res = await apiClient.get<ApiResponse<CommunicationListResponse>>(url);
    return res.data.data;
  },

  async getDetail(deliveryLogId: string): Promise<CommunicationDetail> {
    const res = await apiClient.get<ApiResponse<CommunicationDetail>>(
      `/communications/${deliveryLogId}`,
    );
    return res.data.data;
  },

  async retrigger(
    deliveryLogId: string,
    body?: RetriggerCommunicationRequest,
  ): Promise<RetriggerCommunicationResponse> {
    const res = await apiClient.post<ApiResponse<RetriggerCommunicationResponse>>(
      `/communications/${deliveryLogId}/retrigger`,
      body ?? { triggeredFrom: 'PATIENT360' },
    );
    return res.data.data;
  },
};

export type { Communication };
